import { buildKkFileViewPreviewUrl } from '../../utils/kkfileview'

/** 后端关联行附件（兼容多种字段名） */
export type ParsedAttachment = {
  name: string
  previewHref: string
  downloadHref: string
}

function firstUrl(item: Record<string, unknown>): string {
  const u =
    item.url ??
    item.fileUrl ??
    item.file_url ??
    item.link ??
    item.href ??
    item.downloadUrl ??
    item.download_url
  return u != null ? String(u).trim() : ''
}

/** 从关联业务行解析附件列表 */
export function parseRowAttachments(row: Record<string, unknown>): ParsedAttachment[] {
  const raw =
    row.attachments ??
    row.attachmentList ??
    row.attachment_list ??
    row.supplementAttachments ??
    row.supplement_attachments ??
    row.files ??
    row.appendixList ??
    row.appendix_list
  if (!Array.isArray(raw)) return []
  const out: ParsedAttachment[] = []
  raw.forEach((item: unknown, i: number) => {
    if (!item || typeof item !== 'object') return
    const o = item as Record<string, unknown>
    const base = firstUrl(o)
    if (!base) return
    const name = String(o.name ?? o.fileName ?? o.file_name ?? o.title ?? o.erp_attachment_name ?? `附件${i + 1}`)
    const preview = String(o.previewUrl ?? o.preview_url ?? base).trim()
    const download = String(o.downloadUrl ?? o.download_url ?? base).trim()
    out.push({ name, previewHref: preview, downloadHref: download })
  })
  return out
}

/** 单条附件：通过 kkFileView 在线预览（Word/PDF/Excel/PPT/图片等） */
export function AttachmentItemLinks({ item }: { item: ParsedAttachment }) {
  const fileUrl = item.previewHref || item.downloadHref
  const previewUrl = buildKkFileViewPreviewUrl(fileUrl)
  if (!previewUrl) return <span className="text-gray-400">-</span>
  return (
    <a href={previewUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 shrink-0">
      预览
    </a>
  )
}

export function AttachmentLinksCell({ row }: { row: Record<string, unknown> }) {
  const items = parseRowAttachments(row)
  if (!items.length) return <span className="text-gray-400">-</span>
  return (
    <div className="text-left w-full min-w-0 flex flex-col gap-2">
      {items.map((it, idx) => (
        <div key={`${it.previewHref}-${idx}`} className="flex flex-wrap items-start gap-x-2 gap-y-1 w-full">
          <span className="text-gray-700 break-all min-w-0 flex-1" title={it.name}>
            {it.name}
          </span>
          <AttachmentItemLinks item={it} />
        </div>
      ))}
    </div>
  )
}
